import { client } from '~/data/client';
import {
  MessageChatbotDocument,
  MessageChatbotMutation,
  MessageChatbotMutationVariables,
  ProcessChatbotMessageDocument,
  ProcessChatbotMessageMutation,
  ProcessChatbotMessageMutationVariables
} from '~/data';

/**
 * Send message to the ChatBot
 * @param variables The GraphQL query variables
 * @returns The values that have been updated
 */
export async function sendMessage(variables: { id: string; message: string }) {
  const result = await client.mutate<
    MessageChatbotMutation,
    MessageChatbotMutationVariables
  >({
    mutation: MessageChatbotDocument,
    variables
  });

  if (result.errors?.length || result.data?.messageChatbot?.errors.length) {
    throw new Error('Error sending message...');
  }

  return result?.data?.messageChatbot?.chatbotMessages;
}

export async function processChatBotMessage(variables: {
  learnerTrainingUuid: string | undefined;
  message: string;
}) {
  const result = await client.mutate<
    ProcessChatbotMessageMutation,
    ProcessChatbotMessageMutationVariables
  >({
    mutation: ProcessChatbotMessageDocument,
    variables: variables as ProcessChatbotMessageMutationVariables
  });

  if (
    result.errors?.length ||
    result?.data?.processChatbotMessage?.errors.length
  ) {
    throw new Error('Error sending message...');
  }

  return result?.data?.processChatbotMessage?.chatbotChannel;
}
